import getField from '@form/formGenerator'

export const loginUrl = `${import.meta.env.VITE_API_URL}/tokenize`

export const loginFormObject = {
  email: null,
  password: null
}

export const loginFormFields = (loginFormObject, updateFormObject, loginAction, errors, isLoading, t) => {
  const fields = [
    {
      type: 'email',
      name: 'email',
      label: t('labels.email'),
      value: loginFormObject.email,
      key: 'loginFormObject-email',
      cssClass: 'column is-12'
    },
    {
      type: 'password',
      name: 'password',
      label: t('labels.password'),
      value: loginFormObject.password,
      key: 'loginFormObject-password',
      cssClass: 'column is-12'
    },
    {
      type: 'button',
      buttons: true,
      callback: loginAction,
      cancel: false,
      validateText: t('actions.login'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button login-button',
      validateIcon: 'icon-done',
      key: 'loginFormObject-form',
      isLoading
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}